import React, { useState } from "react";
import { useFormikContext } from "formik";
import { Input, SaveButton } from "components";
import "../../CreateNewEmployee/ImageUpload.css"

export const FormPersonalData = ({ action, setFileValue, loading, isDisabled }) => {
  const { values, errors, touched, setValues } = useFormikContext() ?? {}
  console.log("val", values)
  const [imageViews, setImageView] = useState({ file: null, view: null })
  const { REACT_APP_API_BASE_URL } = process.env

  const ImageProfile = () => (
    <div className="custom-file-upload fas">
      <div className="img-wrap" >
        <img 
          className="uploadFoto" 
          for="photo-upload" 
          src={imageViews?.view 
            ? imageViews?.view 
            : values?.vendor_Foto
            ? `${REACT_APP_API_BASE_URL}/getimage/?imgpath=${values?.vendor_Foto}`
            : "https://www.zedemy.com/wp-content/plugins/buddyboss-platform/bp-core/images/profile-avatar-buddyboss.png"
          }
        />
      </div>
    </div>
  )

  return (
    <>
      <div className="d-flex justify-content-center my-2"><ImageProfile /></div>
      <input 
        type="file" 
        onChange={(e) => {
          setFileValue(e.target.files[0])
          const selectedFile = e.target.files[0];

          if(action === "UPDATE") {
            setFileValue(values?.vendor_Foto)
          }

          if (selectedFile) {
            setImageView({ ...imageViews, file: selectedFile ?? values?.vendor_Foto});
            const reader = new FileReader();
            reader.onloadend = () => {setImageView({ ...imageViews, view: reader.result})};
            reader.readAsDataURL(selectedFile);
          } else {
            setImageView({ ...imageViews, file: null, view: null});
          }
        }}
      />
      <Input
        label="Id Vendor"
        type="text"
        placeholder={action !== "READ" && "Input id vendor"}
        value={values?.vendor_code}
        onChange={(e) => setValues({ ...values, vendor_code: e?.target?.value })}
        error={Boolean(errors?.vendor_code && touched?.vendor_code)}
        errorText={Boolean(errors?.vendor_code && touched?.vendor_code) && errors?.vendor_code}
        readOnly
      />
      <Input
        label="Full Name *"
        type="text"
        placeholder={action !== "READ" && "Input full name"}
        value={values?.vendor_name}
        onChange={(e) => setValues({ ...values, vendor_name: e?.target?.value })}
        error={Boolean(errors?.vendor_name && touched?.vendor_name)}
        errorText={Boolean(errors?.vendor_name && touched?.vendor_name) && errors?.vendor_name}
        readOnly={action === "READ"}
      />
      {action !== "READ" && <div className="d-flex justify-content-end mt-3">
        <SaveButton icon forModal type="submit" loading={loading} disabled={isDisabled} />
      </div>}
    </>
  );
};
